export default "__VITE_ASSET__DVenL4K7__"